import React, {
  useEffect,
  useRef,
} from 'react';
import classNames from 'classnames';
import Immutable from 'immutable';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { Paragraph } from '@uncinc/react-drupal-core';

import { ParagraphsRenderer } from '../../../components';

import {
  blendHexColors,
  setPrimaryColor,
  setPrimaryColorOpaque,
} from '../../../helpers/colors';

import { HOMEPAGE_COLOR, WHITE } from '../../../config/constants';

import './style.scss';

const NodeHomepage = ({ entity, className }) => {
  const classes = classNames(className, 'NodeHomePage');
  const node = entity.toJS();
  const heroTitle = node.title[0]?.value;
  const heroBody = node.body?.[0]?.processed;

  const paragraphs = node.field_paragraphs;
  const firstParagraph = paragraphs[0];
  const id = firstParagraph.target_id;
  const lang = firstParagraph.entity.langcode[0].value;

  const hero = useRef(null);
  const heroHeight = useRef(1000);

  const handleScroll = () => {
    const ratio = Math.max(0, Math.min(1, 1 - (0.3 + ((heroHeight.current - window.scrollY) / 1000))));
    const blendedColor = blendHexColors(HOMEPAGE_COLOR, WHITE, ratio);
    setPrimaryColorOpaque(blendedColor);
  };

  useEffect(() => {
    setPrimaryColor(HOMEPAGE_COLOR);
    setPrimaryColorOpaque(HOMEPAGE_COLOR);
    // comment this line out when on local if
    // working on firefox and it's necessary to view the elements tab in the inspector
    // see "Firefox scrolling performance issues" section in README for explanation
    window.addEventListener('scroll', handleScroll);

    if (hero.current) {
      const backgroundHeight = hero.current.getBoundingClientRect().height;
      heroHeight.current = backgroundHeight > 1000 ? backgroundHeight : 1000;
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
      setPrimaryColor(WHITE);
      setPrimaryColorOpaque(WHITE);
    };
  });

  return (
    <article
      itemType="http://schema.org/WebPage"
      className={classes}
    >
      <div
        ref={hero}
        className="NodeHomePage__background"
      >
        <Container>
          <div className="row">
            <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
              <div className="NodeHomePage__hero__wrapper">
                <div className="NodeHomePage__hero__wrapper__text">
                  <h1 className="NodeHomePage__hero__wrapper__title">{heroTitle}</h1>
                  {heroBody && (
                    <div className="NodeHomePage__hero__wrapper__body">
                      <WysiwygField
                        property="schema:text"
                        className="text--large"
                        html={heroBody}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <Paragraph
            key={`paragraph:${id}:${lang}`}
            id={id}
            entity={Immutable.fromJS(firstParagraph.entity)}
            isHomepage
          />

        </Container>
      </div>

      <Container>
        <ParagraphsRenderer paragraphs={Immutable.fromJS(paragraphs.slice(1))} isHomepage />
      </Container>
    </article>
  );
};

export default NodeHomepage;
